import { initializeApp } from 'firebase/app'
import { getRemoteConfig } from 'firebase/remote-config'

const apiKey =
  process.env.REACT_APP_FIREBASE_API_KEY ||
  'AIzaSyBb6Yqi0gOAHIkryaS6SXITkMUZ-RNqpLA'

const authDomain =
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
  'com-bedee-dev-app.firebaseapp.com'

const databaseURL =
  process.env.REACT_APP_FIREBASE_DATABASE_URL ||
  'https://com-bedee-dev-app-default-rtdb.asia-southeast1.firebasedatabase.app'

const projectId =
  process.env.REACT_APP_FIREBASE_PROJECT_ID || 'com-bedee-dev-app'

const storageBucket =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
  'com-bedee-dev-app.appspot.com'

const messagingSenderId =
  process.env.REACT_APP_FIREBASE_MSG_SENDER_ID || '759226402188'

const appId =
  process.env.REACT_APP_FIREBASE_APP_ID ||
  '1:759226402188:web:366d2202a0b54e2c68c2a9'

const firebaseConfig = {
  apiKey,
  authDomain,
  databaseURL,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
}

const app = initializeApp(firebaseConfig)
const remoteConfig = getRemoteConfig(app)

remoteConfig.defaultConfig = {
  PHONE_NUMBER_MAX: 15,
  PHONE_NUMBER_MIN: 5,
}

remoteConfig.settings = {
  minimumFetchIntervalMillis: 60000,
}

export { remoteConfig }
